import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./pageTitle.css";

const PageTitle = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter((segment) => segment);

  return (
    <div className="pagetitle">
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/dashboard">
              <i className="bi bi-house-door"></i> 
            </Link>
          </li>
          {pathSegments.map((segment, index) => {
            const pathUrl = `/${pathSegments.slice(0, index + 1).join("/")}`;
            return (
              <li className="breadcrumb-item" key={index}>
                {index === pathSegments.length - 1 ? (
                  <span>{segment.replace(/-/g, " ")}</span> // Last segment (active)
                ) : (
                  <Link to={pathUrl}>{segment.replace(/-/g, " ")}</Link> // Clickable breadcrumb
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default PageTitle;
